import moment from "moment";
import { memo } from "react";
import { formatToValue } from "../../../../utils/formatNumber";
import { CustomChartToolTip } from "../../styles/DashBoard";

const Tooltip = ({ active, payload, label, strDateFormat }) => {
  if (!active || !payload?.length) return null;
  return (
    <CustomChartToolTip>
      <p>
        Data {moment(label).format(strDateFormat)}
        {"\n"}
      </p>
      {payload.map((index) => (
        <p key={index.name} style={{ color: index.color }}>
          {index.name}: R$ {formatToValue(index.value)}
          {"\n"}
        </p>
      ))}
    </CustomChartToolTip>
  );
};

export default memo(Tooltip);
